import Article, { ArticleProps } from './Article';

export default Article;
export type { ArticleProps };
